module.exports = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    <app-doctor></app-doctor>\n  </div>\n</div>"